<script setup>

const dairamon = useDairamon();
//const { data } = await dairamon.pages.get(237);
//const { data } = await dairamon.pages.getByURL('home');
//const { data } = await dairamon.products.get({ limit: 1, sort: 'abc' });
//const product = data.value.products[0];
//console.log(product.image)
//throw new Error('Staging error test message');

onMounted(() => {
  dairamon.storage.removeItem('drm_breakpoint');
})
</script>

<template>
<!--
  <DImage :img="product.image"></DImage>
-->
  <div>
  </div>
</template>


